/**
 * Modals will start at this given z-index and increment by one each time
 * a new modal is added. The dark bg will always be at the same z-index as
 * the frontmost modal so that modals in the background are also darkened.
 */
export const zIndexStart = 150;

export const MODAL_TYPES = {
    BETSLIP: 'BETSLIP_MODAL',
    ONBOARDING: 'ONBOARDING_MODAL',
    BETBUILDER: 'BETBUILDER_MODAL',
    LONG_ARTICLE: 'LONG_ARTICLE_MODAL',
    WORLDCUPHUB: 'WORLDCUPHUB_MODAL',
};

/**
 * Certain Modals we want to allow the baby betslip to be accessible under them.
 */
export const MODAL_DISPLAY_BABY_BETSLIP = [MODAL_TYPES.LONG_ARTICLE];
